import { ClipboardList, Key, Truck } from "lucide-react";
import FadeIn from "./FadeIn";
import { scrollToAnchor } from "@/lib/scrollToAnchor";
import { trackCTAClick } from "@/lib/analytics";
import { useTranslation } from "react-i18next";

const ICONS = [ClipboardList, Key, Truck];

const HowItWorks = () => {
  const { t } = useTranslation();
  const rawSteps = t("howItWorks.steps", { returnObjects: true });
  const steps = (Array.isArray(rawSteps) ? rawSteps : []) as { title: string; desc: string }[];


  return (
    <section id="so-gehts" className="surface-dark">
      <div className="container-site section-y-sm">
        <FadeIn className="max-w-2xl">
          <p className="eyebrow">{t("howItWorks.eyebrow")}</p>
          <h2 className="h2-section">
            {t("howItWorks.titlePre")}
            <span className="text-accent">{t("howItWorks.titleHighlight")}</span>
            {t("howItWorks.titlePost")}
          </h2>
          <p className="lead mt-3">{t("howItWorks.subtitle")}</p>
        </FadeIn>

        <div className="mt-8 grid gap-4 sm:grid-cols-3">
          {steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <button
                key={step.title}
                type="button"
                onClick={() => {
                  trackCTAClick("howitworks_step", "howitworks", step.title);
                  scrollToAnchor("fuhrpark", undefined, { highlight: true });
                }}
                aria-label={t("howItWorks.scrollAria")}
                className="group rounded-lg bg-primary-foreground/5 border border-primary-foreground/15 px-5 py-6 h-full w-full text-left transition-colors hover:bg-primary-foreground/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
              >
                <div className="flex items-center gap-3">
                  <Icon className="h-5 w-5 text-accent shrink-0" strokeWidth={1.75} />
                  <span className="text-[11px] font-bold tracking-[0.14em] text-primary-foreground/70">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="h3-block mt-4">{step.title}</h3>
                <p className="text-sm text-primary-foreground/75 leading-relaxed mt-2">{step.desc}</p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );

};

export default HowItWorks;
